import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ComboBox } from '@reveni-io/reveni-ui'

import AffectedProductsEditor from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/PolicyRuleActionEditor/AffectedProductsEditor/AffectedProductsEditor'
import CustomMessage from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/PolicyRuleActionEditor/CustomMessage/CustomMessage'

import { customMessageTypeOptions, messagePlacementOptions } from './constants'
import { getErrors, isProductDialogPlacement } from './helpers'
import * as Styles from './styles'

const DisplayMessageConfig = ({
  config,
  onChangeConfig,
  disabled,
  currencies,
  storeCurrencyCode,
  productTypes,
  productCategories,
  productCollections,
  errors = [],
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const { hasPlacementError, hasProductConditionError } = getErrors(errors)
  const showAffectedProducts = isProductDialogPlacement(config.display_message_placement)
  const placementOptions = messagePlacementOptions.map(option => ({ value: option.value, label: t(option.labelKey) }))

  const handleChangePlacement = e => onChangeConfig({ display_message_placement: e.target.value })

  return (
    <Styles.Container>
      <CustomMessage
        showToggle={false}
        message={config.custom_message}
        customMessageType={config.custom_message_type}
        customMessageTypeOptions={customMessageTypeOptions}
        onChangeConfig={onChangeConfig}
        disabled={disabled}
        errors={errors}
      />
      <ComboBox
        label={t('Posición del mensaje')}
        menuItems={placementOptions}
        handleChange={handleChangePlacement}
        value={config.display_message_placement || ''}
        fullWidth
        disabled={disabled}
        backgroundColor={theme.colors.background.primary}
        error={hasPlacementError}
        helperText={hasPlacementError ? t('Este campo es obligatorio') : ' '}
      />
      {showAffectedProducts && (
        <AffectedProductsEditor
          config={config}
          onChangeConfig={onChangeConfig}
          disabled={disabled}
          currencies={currencies}
          storeCurrencyCode={storeCurrencyCode}
          productTypes={productTypes}
          productCategories={productCategories}
          productCollections={productCollections}
          hasError={hasProductConditionError}
        />
      )}
    </Styles.Container>
  )
}

export default DisplayMessageConfig
